module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_6_2.bd76933e.png";